import { makeAutoObservable, runInAction } from 'mobx'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { SearchDropdownContactsStore } from 'widgets/SearchDropdown/store/searchDropdownContactsStore'

export class WidgetContactsStore {
  private _loading = true
  readonly searchDropdownContactsStore: SearchDropdownContactsStore

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)

    this.searchDropdownContactsStore = new SearchDropdownContactsStore(this._entities)
  }

  init = () => {
    this.searchDropdownContactsStore.initOptions({
      selectedMode: true,
    })
  }

  dispose = () => {
    this.searchDropdownContactsStore.reset()
    this._loading = false
  }

  setItems = async (ids: number[]) => {
    runInAction(() => {
      this._loading = true
    })

    if (!ids.length) {
      runInAction(() => {
        this._loading = false
      })

      return
    }

    const items = await this._entities.contactsStore.getByIds(ids)

    runInAction(() => {
      items.forEach((item) => {
        this.searchDropdownContactsStore.toggleTypeItem(item)
      })

      this._loading = false
    })
  }

  get selectedItems() {
    return this.searchDropdownContactsStore.selectedItems
  }

  get selectedKeys() {
    return this.selectedItems.map((item) => item.id)
  }

  get loading() {
    return this._loading
  }
}
